export enum AccountType {
  SiegeCentrale = '0 - Siège Centrale',
  BTP = '1 - BTP',
  AgenceMagasin = '2 - Agence Magasin',
  EntrepriseTravaux = '3 - Entreprise de travaux',
  GCEntreprise = '4 - GC Entreprise',
  GCCollectivite = '5 - GC Collectivité',
  BailleurSocial = '6 - GC Bailleur social',
  Oblige = '7 - Oblig',
  Presse = '8 - Presse',
  PartenaireGEOPLC = '9 - Partenaire GEOPLC',
  BureauEtude = "10 - Bureau d'étude",
  AgentIndependant = '12 - Agent indépendant',
  Concessionnaire = '13 - Concessionnaire',
}
export enum PartenaireType {
  Courtier = 'Courtier',
  Consultant = 'Consultant',
  Concessionnaire = 'Concessionnaire',
  LeadReferent = 'Partenaire Lead',
  BailleurSocial = 'Partenaire CEE Bailleur Social',
  ETX = 'Partenaire CEE ETX',
  PartenaireAutre = 'Partenaire CEE Autre',
}
